import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import adddownloadAddress from "./components/adddownloadAddress";
export default {
  name: "downloadAddress",
  mixins: [loadMoreList, serchSelect],
  components: {
    adddownloadAddress: adddownloadAddress
  },
  data: function data() {
    return {
      pagingReqFn: "downLoadData",
      pagingReqValue: "",
      paramsData: {
        id: '',
        name: '',
        language: ''
      },
      tableBody: 'downloadAddressTable',
      sortReq: 'downloadLinkChangeSort'
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'downloadLinkDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};